export default "__VITE_ASSET__C7Xa9bG0__"